// extracted by mini-css-extract-plugin
export var footer = "_nr-0";
export var inherit = "_nr-1";
export var input = "_nr-2";
export var modalContent = "_nr-3";
export var quillEditor = "_nr-4";
export var subtitle = "_nr-5";